<template>
    <div class="ReMapAddress row">
		<div class="form-group col-md-12">
			<h5  v-if="objectType == 'HOUSE' || objectType == 'LAND' || objectType == 'COMM_LAND'">
				<i class="tim-icons text-danger icon-alert-circle-exc mr-2" style="font-size: 16px;"></i>
				<b class="text-danger">ЗАГОРОДНАЯ НЕДВИЖИМОСТЬ: </b> 
				При добавлении объекта (земельный участок, жилой дом), где отсутствует точный адрес объекта (улица, дом), указывайте метку в пределах конкретного населенного пункта. 
				В описании укажите комментарий: "Адрес объекта отсутствует на Яндекс картах, поэтому указан ближайший. Точный адрес: ..."
			</h5>
			<h5><i class="tim-icons text-danger icon-alert-circle-exc mr-2" style="font-size: 16px;"></i> После ввода адреса в поле "Адрес" подтверждайте его выбором из выпадающего списка. Убедитесь, что метка на карте располагается верно.</h5>
			<div class="d-flex align-items-center mb-0">
				<div class="ReInputSearchDrop w-100">
					<base-input
						placeholder="Введите адрес"
						addon-left-icon="tim-icons icon-zoom-split"
						v-model="value.address.inputText"
						@blur="checkInputText"
						autocomplete="off"
						ref="suggest"
						@focus="initSuggest"
					>
					</base-input>
					<!--
					<ul v-if="bInSearch" class="my-0 mb-1 w-100 dropdown-menu show">
						<li class="searchProg dropdown-item cursor-pointer">Поиск данных <i class="tim-icons icon-refresh-02 rotate"></i></li>
					</ul>
					<ul v-if="!bInSearch" :class="[{'show':masDataOpt.length > 0},]" v-click-outside="hide" class="my-0 mb-1 w-100 dropdown-menu">
						<li v-for="opt in masDataOpt" :key="opt.value"
							@click="ClickOnOpt(opt)"
							style="white-space: normal;"
							class="dropdown-item cursor-pointer" v-html="PrintOptText(opt)"></li>
					</ul>
					-->
				</div>
				<!--
				<button class="ml-3 btn btn-simple btn-success btn-search" @click="yaSearch(value.address.inputText)">
					<i class="tim-icons icon-zoom-split mr-1"></i>
					<div class="d-inline-flex btn-search-txt">Найти</div>
				</button>
				-->
			</div>
		</div>
        <yandex-map
            :settings="settings"
            :coords="value.coords"
            :zoom="zoom"
            :controls="controls"
            @map-was-initialized="mapInit"
            @click="mapClick"
			class="px-3"
        >
            <ymap-marker 
                :coords="value.coords" 
                marker-id="main_marker" 
                :hint-content="value.address.text" 
            />
			<!--
            <ymap-marker 
                :coords="coord1" 
                marker-id="marker-1" 
                hint-content="уменьшение" 
				
            />
            <ymap-marker 
                :coords="coord2" 
                marker-id="marker-2" 
                hint-content="main_marker hint" 
            />
            <ymap-marker 
                :coords="coord3" 
                marker-id="marker-3" 
                hint-content="main_marker hint" 
            />
            <ymap-marker 
                :coords="coord4" 
                marker-id="marker-4" 
                hint-content="main_marker hint" 
            />
            <ymap-marker 
                :coords="coord44" 
                marker-id="marker-44" 
                hint-content="округлили до 4-х знаков" 
				:options="markerOptions"
            />			
			-->
        </yandex-map>

        <h5 class="mt-3 col-md-12">Адрес: {{value.address.inputText}}</h5>
		<div id="flatNumber">
			<label class="col-form-label col-md-12 " > 
				<!-- <span>Номер квартиры(офиса)</span>  -->
				{{ flatNumPlaceholder }}
			</label>
			<div class="col-md-12">
				<div class="form-group">
					<div class="mb-0">
						<input type="number" placeholder="Введите номер" class="form-control" v-model.lazy="value.flat_num">
					</div>
				</div>
			</div>
		</div>

		<div class="px-3">
			<label class="col-form-label col-md-12 " ><span class="">Регион </span><span class="hohoho">*обязательно</span></label>
			<el-select  v-if="masRegions.length > 0"
					class="select-primary"
					placeholder="Регион"
					@change="OnRegionChange"
					v-model="value.address.regioncode"
					filterable
				>
				<el-option
					v-for="item in masRegions"
					class="select-primary"
					:key="item.value"
					:label="item.label"
					:value="item.value"
				>
				</el-option>
			</el-select>

			<template>
				<!-- <label class="col-form-label col-md-12 formRequired" ><div class="d-inline-block"> <span> Метро:</span></div></label> -->
				<ReInputMetro
					:region="value.address.regioncode"
					v-model="value.arrMetro"
					required
				/>
			</template>
			<template v-if="masDistricts.length > 0">
				<label class="col-form-label col-md-12" ><span class="">Район </span></label>
				<el-select
						class="select-primary"
						placeholder="Район"
						@change="onDistrChange"
						v-model="value.distr_id"
					>
					<el-option
						v-for="item in masDistricts"
						class="select-primary"
						:key="item.id"
						:label="item.cellName"
						:value="item.id"
					>
					</el-option>
				</el-select>
			</template>
		</div>

        <div class="mt-3 col-md-12"><base-checkbox @input="onbNotOnMap" :checked="bNotOnMap" v-model="bNotOnMap">Автоматически найденный адрес неверный</base-checkbox></div>
        <div v-if="bNotOnMap" class="w-100">
            <label class="col-form-label col-md-12" ><div class="d-inline-block">Введите адрес</div></label>
			<div v-if="bNotOnMap" class="form-group col-md-12">
				<ReInputSearchDrop 
					placeholder="Введите адрес"
					v-model="value.address"
					:objApiMethod="addrObjApiMethod"
					:strApiMethodKey="strApiMethodKey"
					:strType="strType"
					:disableCache="true"
					v-on:change="OnAjaxListSearch"
				/>
			</div>
			<div v-else class="col-md-12">
				<div class="form-group">
					<div class="mb-0">
						<input type="text" placeholder="Введите адрес" class="form-control" v-model.lazy="value.address.inputText">
					</div>
				</div>
			</div>
        </div>
    </div>
</template>
<script>
import { yandexMap, ymapMarker, loadYmap } from 'vue-yandex-maps';
import { Select, Option } from 'element-ui';
import { BaseCheckbox, /*BaseRadio,*/ } from 'src/components/index';
import ReInputSearchDrop from 'src/our_components/ReInputSearchDrop.vue';
import ReInputMetro from "src/our_components/ReInputMetro.vue";

import mapSettings from 'src/conf/yandexmap.js';

export default {
    name: 'ReMapAddress',
    components: {
        yandexMap, ymapMarker,
        [Option.name]: Option,
		[Select.name]: Select,
		BaseCheckbox,
		ReInputSearchDrop,
		// BaseRadio,
		ReInputMetro,
    },
    props:{
        value:{
            type: Object,
            default(){
                return {
                    coords: [59.93984485554249, 30.314527237792984],
                    flat_num: '',
                    address: {
						inputText: '',
						selectedVal: '',
						ad4_id: '',
						ad4_name: '',
						ad4_short: '',
						ad5_id: '',
						ad5_name: '',
						ad5_short: '',
						ad6_id: '',
						ad6_name: '',
						ad6_short: '',
						ad7_id: '',
						ad7_name: '',
						ad7_short: '',
						ad8_id: '',
						ad8_name: '',
						ad8_short: '',
						regioncode: '78',
						regionname: 'г Санкт-Петербург',
						text: '',
						text_addr: '',
						value: '',
						bNotOnMap: false,
					},
					arrMetro:[],
					distr_id:'',
					distr_name:'',
                }
            }
        },
        /**
         * Настройки карты
         */
        settings:{
            type: Object,
            default(){
                return mapSettings
				/*{
                    apiKey: '7f037fcc-21f0-4c1b-ad6e-1f292ef45a2f',
                    lang: 'ru_RU',
                    coordorder: 'latlong',
                    version: '2.1'
                }*/

            },
        },
        /**
         * величина зума (приближения) при её создании
         */

		zoom:{
            type: Number,
            default: 16,
        },
        /**
         * Список активных элементов в карте
         *  */        
		controls:{
            type: Array,
            default(){return ['zoomControl','typeSelector']},
        },
		flatNumPlaceholder: {
			type: String,
            default: 'Номер квартиры(офиса)',
		},
		objectType:{
			type: String,
            default: 'FLAT',
		}
    },
    data(){
        return {
            map:null,
			suggestView:null,
			needInitSuggest:false,
            masRegions:[
				{value: '78', label: 'Санкт-Петербург',},
				{value: '77', label: 'Москва',},
				{value: '35', label: 'Вологодская обл.',},
			],
			masCountrys:[
				{value: 1, label: 'Россия',},
			],
			masDistricts: [],
            countryId: 1,
			bNotOnMap: false,
			addrObjApiMethod:{'obj': 'address', 'flt': {'addr': '','regioncode': '78'}},
			strApiMethodKey: 'addr',
			strType: 'address.addr',
			bInSearch: false,
			masDataOpt: [],
			cacheOpt: {},
        };
    },
	computed:{
		/*
		bNotOnMap:{
			get(){ console.log('g'); return this.value.address.bNotOnMap||false; },
			set(val){ 
				console.log('s',val,this.value.address); 
				this.$set(this.value.address, 'bNotOnMap', val);
				this.value.address.bNotOnMap = val;
			},
		},
		*/
		coord1(){
			return [Math.floor(this.value.coords[0]*10000)/10000, Math.floor(this.value.coords[1]*10000)/10000, ]
		},
		coord2(){
			return [Math.ceil(this.value.coords[0]*10000)/10000, Math.floor(this.value.coords[1]*10000)/10000, ]
		},
		coord3(){
			return [Math.ceil(this.value.coords[0]*10000)/10000, Math.ceil(this.value.coords[1]*10000)/10000, ]
		},
		coord4(){
			return [Math.floor(this.value.coords[0]*10000)/10000, Math.ceil(this.value.coords[1]*10000)/10000, ]
		},
		coord44(){
			return [Math.round(this.value.coords[0]*10000)/10000, Math.round(this.value.coords[1]*10000)/10000, ]
		},
		markerOptions(){
			return {
				preset:"islands#grayCircleDotIcon",
			};
		},
	},
    watch:{
		value:{
			handler(value){
				this.$emit('input', value);
			},
			deep: true,
		}
    },
    methods:{
		onbNotOnMap(e){
			// this.bNotOnMap = e;
		},
        mapClick(e) {
            this.value.coords = e.get('coords');
			// console.log('map click', this.value.coords, this.bNotOnMap);
			if(this.bNotOnMap===false){
				// console.log(ymaps, this.settings);
				ymaps.geocode(this.value.coords,{apikey: this.settings.apiKey}).then(res => {
					// console.log('geocode finish');
					let firstGeoObject = res.geoObjects.get(0);
					// console.log(firstGeoObject.properties._data.metaDataProperty.GeocoderMetaData.Address.Components);
					//console.log(firstGeoObject.getLocalities());
					//console.log(firstGeoObject.getAdministrativeAreas()); //административные округа - районы
					//console.log(firstGeoObject.getThoroughfare());
					//console.log(firstGeoObject.getPremiseNumber());
					//console.log('firstGeoObject.properties.get("metaDataProperty.GeocoderMetaData")',firstGeoObject.properties.get("metaDataProperty.GeocoderMetaData"));
					// https://yandex.ru/dev/maps/jsapi/doc/2.1/ref/reference/GeocodeResult.html
					this.value.address = {
						inputText:'',
						selectedVal:'',
						ad4_id:'',
						ad4_name:'',
						ad4_short:'',
						ad5_id:'',
						ad5_name:'',
						ad5_short:'',
						ad6_id:'',
						ad6_name:'',
						ad6_short:'',
						ad7_id:'',
						ad7_name:'',
						ad7_short:'',
						ad8_id:'',
						ad8_name:'',
						ad8_short:'',
						regioncode: '78',
						regionname: 'г Санкт-Петербург',
						text: '',
						text_addr: '',
						value: '',
						yaAddrComponents: firstGeoObject.properties._data.metaDataProperty.GeocoderMetaData.Address.Components
					};
					// debugger;
					let objAdministrativeAreas = firstGeoObject.getAdministrativeAreas();
					if(objAdministrativeAreas.length === 2){
						//this.value.address.regionname = "";
						//this.value.address.regioncode = "";
						this.value.address.ad4_name = objAdministrativeAreas[0];
						this.value.address.ad5_name = objAdministrativeAreas[1];
					}

					this.value.address.inputText = firstGeoObject.getAddressLine();
					this.value.address.text = firstGeoObject.getAddressLine();
					// this.value.address.text_addr = firstGeoObject.getAddressLine(); // оригинальная версия, адрес с номером дома
					let masCity = firstGeoObject.getLocalities();
					if(masCity.length==0) masCity = [firstGeoObject.getPremise()]
					this.value.address.ad6_name = masCity[0];
					this.value.address.ad7_name = firstGeoObject.getThoroughfare();
					this.value.address.ad8_name = firstGeoObject.getPremiseNumber();
					let addr = [
						this.value.address.ad5_name,
						this.value.address.ad6_name,
						this.value.address.ad7_name,
					]
						.filter(v=>v>'')
						.join(', ');
					this.value.address.text_addr = addr;
					// this.value.address.ad5_name+', '+masCity[0];
					// if(this.value.address.ad7_name) masCity +=  ', ' + this.value.address.ad7_name; // для зипала нужен адрес без номера дома

					this.OnCoordChange();
				}).catch(e=>{
					// console.log('geocode error',e)
					this.$GVO.showAlert('Ошибка','Ошибка получения адреса с карты.<br/>Попробуйте перезагрузить страницу');
				});
			}else{
				this.OnCoordChange();
			}
			//this.OnCoordChange();
        },
        mapInit(myMap){
			// console.log('mapinit',this,myMap);
            this.map=myMap;
			if(this.needInitSuggest)
				this.initSuggest();
			// console.log(this);
        },
		initSuggest(){
			if(!this.suggestView && this.map){
				this.suggestView = new ymaps.SuggestView(this.$refs.suggest.$el.querySelector('input'),{results:10});
				this.suggestView.events.add('select',this.selectAddress);
			}else{
				this.needInitSuggest = true;
			}
		},
		buildAddressObj(context){
			// console.log('build address', context);
			let strAddr = context.getAddressLine();
			let masCoords = context.geometry.getCoordinates();
			let Localities = context.getLocalities();
			let Thoroughfare = context.getThoroughfare();
			let PremiseNumber = context.getPremiseNumber();
			let objAdministrativeAreas = context.getAdministrativeAreas();
			return {
				'text': strAddr,
				'value': masCoords.join('#'),
				'objAdministrativeAreas': objAdministrativeAreas,
				'Localities': Localities[0],
				'Thoroughfare': Thoroughfare,
				'PremiseNumber': PremiseNumber,
			};
		},
		selectAddress(event){
			let address = event.originalEvent.item.value;
			this.value.address.inputText = address;
			ymaps.geocode(
				address,
				{
					results: 1,
					kind:'house',
					boundedBy:[[59.40838788408754, 28.182632410903928],[60.785204345571046, 31.275283778091396]],
					// strictBounds:true,
				}
			).then(res => { // boundedBy - Прямоугольная область на карте, где предположительно находится искомый объект. strictBounds:true - Искать только внутри области, заданной опцией boundedBy.
				this.masDataOpt = [];
				this.bInSearch = false;
				res.geoObjects.each((context)=>{
					this.ClickOnOpt(this.buildAddressObj(context));
				});
			}).catch(console.error);
			return true;
		},
        isRF(objAddr){
			if(this.countryId === '1' || this.countryId === 1) return true;
			return false;
		},
        OnRegionChange(val){
			this.value.distr_id='';
			this.value.distr_name='';
			this.addrObjApiMethod.flt.regioncode = val;
			for (let i = 0; i < this.masRegions.length; i++) {
				if(this.masRegions[i].value==val)
					this.value.address.regionname = this.masRegions[i].label;
			}
			this.getDistrict();
		},
		onDistrChange(val){
			for (let i = 0; i < this.masDistricts.length; i++) {
				if(this.masDistricts[i].id==val)
					this.value.distr_name = this.masDistricts[i].cellName;
			}
		},
		searchMetro(coord){
			this.$GVO.ApiCall('cat_subway.GEOCODE',{flt: {lat: coord[0], lng: coord[1]}})
			.then((objApi) => {
				//this.masDistricts = [];
				if(objApi.success === true){
					if(objApi.data.length > 0){
						// console.log('subway', objApi.data);
						//this.masDistricts = objApi.data;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));			
			// Формат данных получаемых из АПИ
			/*
			[
				{'metro_id':111,'metro_name':'какое-то метро','lat':32.33333, 'lng':23.3232323},
				{'metro_id':222,'metro_name':'какое-то метро2','lat':32.33333, 'lng':23.3232323},
			]
			*/
		},
		searchDistrict(coord){
			this.$GVO.ApiCall('cat_districts.GEOCODE',{flt: {lat: coord[0], lng: coord[1]}})
			.then((objApi) => {
				//this.masDistricts = [];
				if(objApi.success === true){
					if(objApi.data.length > 0){
						// console.log('districts', objApi.data);
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
			// Формат данный получаемых из АПИ
			/*
			{
				'distr_id': 12,
				'distr_name': 'какое-то район'
			}
			*/
		},
		getMetroDistr(coord){
			this.$GVO.ApiCall(['cat_districts.GEOCODE','cat_subway.GEOCODE'],[{flt: {lat: coord[0], lng: coord[1]}},{flt: {lat: coord[0], lng: coord[1]}}])
			.then((objApi) => {
				// console.log('getMetroDistr',objApi);
				this.value.arrMetro = [];
				this.value.address.regioncode = '';
				this.value.distr_name = '';
				this.value.distr_id = '';
				for (let i = 0; i < objApi.length; i++) {
					const objSubwayOrDistr = objApi[i];
					if(objSubwayOrDistr.result.success===true && objSubwayOrDistr.result.data.length>0){
						if(i === 0){ //cat_districts
							// console.log('district load finish');
							const objDistr = objSubwayOrDistr.result.data[0];
							if(objDistr.regioncode == '') objDistr.regioncode = '78';
							this.value.address.regioncode = objDistr.regioncode;
							// чтобы загрузились справочиники
							this.OnRegionChange(objDistr.regioncode);
							this.addrObjApiMethod.flt.regioncode = objDistr.regioncode;
							this.value.distr_name = objDistr.distr_name;
							this.value.distr_id = objDistr.distr_id;
						}
						if(i === 1){ //cat_subway
							//this.value.arrMetro = [];
							for (let x = 0; x < objSubwayOrDistr.result.data.length; x++) {
								const objSubway = objSubwayOrDistr.result.data[x];
								let objMetro = {
									metro_id: objSubway.metro_id,
									metro_name: objSubway.metro_name,
									distanceType: 'WALK',
									distanceToMetro: '',
								}
								this.getDistance(this.value.coords,[objSubway.lat,objSubway.lng],'WALK').then((objD)=>{
										//console.log(objD);
										objMetro.distanceToMetro = parseInt(objD.time.text);
										this.value.arrMetro.push(objMetro);
								}).catch(errorObjApi => console.error(errorObjApi));
							}
						}
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		getDistance(source,dest,type){
			var cache={};
			// Возвращает длину машрута между 2 точками, с использованием соответствующего типа перемещения
			// type 'auto', 'masstransit', 'pedestrian'
			// Route.get([59.90980300,32.17793700],[61.06716600,29.98840100],'auto').then(console.log)
			switch(type){
				case 1:
				case '1':
					type='auto'; // Автомобиль
					break;
				case 2:
				case '2':
				case 'transport':
				case 'TRANSPORT':
				case 'trans':
					type='masstransit'; break; // Общественный транспорт
				case 3:
				case '3':
				case 'walk':
				case 'WALK':
					type='pedestrian'; break; // Пешком
			}
			if (typeof ymaps =='undefined'){
				return Promise.reject('Маршруты не найдены')
			}
			var cachename=source.join(',')+'_'+dest.join(',');
			if(!cache.hasOwnProperty(cachename)){
				cache[cachename]=new Promise(function(d,e){
					var route=new ymaps.multiRouter.MultiRoute({referencePoints:[source,dest],params: {
						routingMode: type,
						results:1,
					}}, {
						wayPointFinishVisible:false,
						boundsAutoApply: true
					});
					route.model.events.add("requestsuccess",function(event){
						var routes = event.get("target").getRoutes();
						if(routes.length>0)
							d({
								dist:route.getRoutes().get(0).properties.get('distance'),
								time:route.getRoutes().get(0).properties.get('duration'),
								route: route
							});
						else{
							delete cache[cachename];
							e('Маршруты не найдены');
						}
					}).add("requestfail", function (event) {
						delete cache[cachename]
						e("Ошибка: " + event.get("error").message);
					});
				})
			}
			return cache[cachename];
		},
		OnCoordChange(){
			const coord=this.value.coords;
			if(coord && coord.length>0){
				//this.searchMetro(coord);
				//this.searchDistrict(coord);
				this.getMetroDistr(coord);
			}
		},
        OnAjaxListSearch(opt){
            //this.value.coords = [];
			//console.log(opt);
			/*
			{
				ad4_id:"6d1ebb35-70c6-4129-bd55-da3969658f5d",
				ad4_name:"Ленинградская область",
				ad4_short:"обл",
				ad5_id:"db8758d6-b8ea-453d-a75f-8f2d3ff49fb0",
				ad5_name:"Всеволожский",
				ad5_short:"р-н",
				ad6_id:"d73506c5-015c-4c39-929a-696ea8144e16",
				ad6_name:"Мурино",
				ad6_short:"г.",
				ad7_id:"871ae2cb-d08e-4f79-a95c-6f29b012ea62",
				ad7_name:"Авиаторов Балтики",
				ad7_short:"пр-кт",
				ad8_id:"38a921de-5a92-4ab2-9ca2-91159c60a79d",
				ad8_name:"11",
				ad8_short:"дом",
				inputText:" обл Ленинградская область р-н Всеволожский г. Мурино пр-кт Авиаторов Балтики дом 11 ",
				regioncode:"47",
				selectedVal:"38a921de-5a92-4ab2-9ca2-91159c60a79d",
				text:" обл Ленинградская область р-н Всеволожский г. Мурино пр-кт Авиаторов Балтики дом 11 ",
				text_addr:" обл Ленинградская область р-н Всеволожский г. Мурино пр-кт Авиаторов Балтики дом 11 ",
				value:"38a921de-5a92-4ab2-9ca2-91159c60a79d"
			}
			*/
		},
		/*
		yaSearch(strSearchText){
			let me = this;
			if(strSearchText.length>4){
				this.bInSearch = true;
				ymaps.geocode(strSearchText,{results: 10, kind:'house', boundedBy:[[59.40838788408754, 28.182632410903928],[60.785204345571046, 31.275283778091396]], strictBounds:true}).then(res => { // boundedBy - Прямоугольная область на карте, где предположительно находится искомый объект. strictBounds:true - Искать только внутри области, заданной опцией boundedBy.
					me.masDataOpt = [];
					me.bInSearch = false;
					res.geoObjects.each(function(context){
						me.masDataOpt.push(this.buildAddressObj(context));
					});
				});
			} else {
				this.masDataOpt = [];
				this.bInSearch = false;
			}
		},
		*/
		checkInputText(evt){
			// debugger;
			/*
			console.log({value:this.value.address.selectedVal,text:this.value.address.inputText});
			console.log(this.cacheOpt);
			if(this.value.address.selectedVal==this.cacheOpt.value && this.value.address.inputText!=this.cacheOpt.text){
				this.value.address.inputText = this.$GVO.unlinkObject(this.cacheOpt.text);
				this.value.address.selectedVal = this.$GVO.unlinkObject(this.cacheOpt.value);
				//this.ClickOnOpt(this.$GVO.unlinkObject(this.cacheOpt));
			}
			*/
		},
		
		ClickOnOpt(opt){
			// console.log('click', opt);
			// debugger;
			const strOldTypedText = this.$GVO.unlinkObject(this.value.address.inputText);
			this.cacheOpt = this.$GVO.unlinkObject(opt);
			this.value.coords = opt.value.split('#');
			if(this.bNotOnMap===false){
				this.value.address.inputText = opt.text;
				this.value.address.text = opt.text;
				this.value.address.selectedVal = opt.value;

				if(opt.objAdministrativeAreas.length === 2){
					//this.value.address.regionname = "";
					//this.value.address.regioncode = "";
					this.value.address.ad4_name = opt.objAdministrativeAreas[0];
					this.value.address.ad5_name = opt.objAdministrativeAreas[1];
				}else{
					this.value.address.ad5_name = '';
				}
				// console.log('ad5', this.value.address.ad5_name);
				this.value.address.ad6_name = opt.Localities;
				this.value.address.ad7_name = opt.Thoroughfare;
				this.value.address.ad8_name = opt.PremiseNumber;
				this.value.address.text_addr = (this.value.address.ad5_name>''?this.value.address.ad5_name+', ':'')+opt.Localities+', '+opt.Thoroughfare;
				// console.log('addr', this.value.address);
			}
			this.masDataOpt = [];
			this.OnCoordChange();
		},
		PrintOptText(opt){
			if (typeof opt.value != 'undefined'){
				if (typeof opt.text != 'undefined'){
					return '<span>'+opt.text+'</span>';
				}
			}
		},
		hide(){
			this.masDataOpt = [];
		},
		getDistrict(){
			let filter = {'list':true,'region':this.value.address.regioncode, act: 1};
			this.$GVO.ApiCall('cat_districts.GET',{flt:{...filter}})
			.then((objApi) => {
				this.masDistricts = [];
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.masDistricts = objApi.data;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
    },
	async mounted() {
		// console.log(';init mapAddr', window.ymaps, document.getElementById('vue-yandex-maps'), this.settings)
        const r = await loadYmap(this.settings);
		// console.log(r);
        this.$GVO.LoadCatPromise('CAT_REGION')
		    .then((objApi) => {
				//console.log(objApi);
				if(objApi=== true){
					this.masRegions = [];
					for (let i = 0; i < this.$GVO.cats.CAT_REGION.length; i++) {
						const element = this.$GVO.unlinkObject(this.$GVO.cats.CAT_REGION[i]);
						this.masRegions.push({value: element.regioncode, label: element.name});
					}
				}
		    }).catch(errorObjApi => console.error(errorObjApi));
		this.$GVO.LoadCatPromise('cat_country')
			.then((objApi) => {
				//console.log(objApi);
				if(objApi=== true){
					this.masCountrys = [];
					for (let i = 0; i < this.$GVO.cats.cat_country.length; i++) {
						const element = this.$GVO.unlinkObject(this.$GVO.cats.cat_country[i]);
						this.masCountrys.push({value: element.id, label: element.name});
					}
				}
            }).catch(errorObjApi => console.error(errorObjApi));
		this.getDistrict();
    }
}
</script>

<style scoped> 
.btn-search{width: 150px;}
#flatNumber {width:100%;}
/*.btn-search-txt {display: none;}*/
.ReMapAddress >>> .ymaps-2-1-79-search__suggest {color: #000!important;}
.hohoho {color: #F84E54;}

</style>